import { EuiButton, EuiFlexGroup, EuiFlexItem } from "@elastic/eui";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { ButtonGroup } from "../../../../shared/components/Buttons/ButtonGroup";
import { Props, Action } from "./interface";
import "./styles.css";

export const Menu = (props:Props) =>{

  let {actions, className} = props;

  const GroupRender = (group:Action[])=> ( (group[0].visible===true || group[0].visible===undefined)  ? <ButtonGroup buttons={group} /> : null)
  

  const getActions = useMemo(() =>{
    return actions.map((a:Action)=>{
      
        return (a.visible === undefined || a.visible) ?(
        <EuiFlexItem grow={false}>
          {a.component===undefined ?
            ((a.actionGroup===undefined) ?
            <EuiButton size={a.size} fill={a.fill===undefined ? true : a.fill} color={a.color} isDisabled={a.isDisabled}
              onClick={()=> a.handle&&a.handle()} className={a.className ? a.className : "menuButton"}>
              {a.text}
            </EuiButton>
            : GroupRender(a.actionGroup.actions)
            )
            : a.component
          }
        </EuiFlexItem>
        ): null
     
    })
  },[actions])

  return (
    <EuiFlexGroup gutterSize="s" alignItems="center" justifyContent="flexEnd" className={className}>
      {getActions}
    </EuiFlexGroup>
  )
}
Menu.propTypes = {
  actions: PropTypes.array,
  className: PropTypes.string
}

Menu.defaultProps = {
  actions: [],
  className:""
}